<template>
	<transition name="bounce" mode="out-in">
      <router-view></router-view>
    </transition>
</template>

<script>
  export default {
  }
</script>

<style>
  .bounce-enter-active {
    animation: bounce-in .5s;
  }
  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }
  @keyframes bounce-in {
    0% {opacity: 0;}
    100% {opacity: 1;}
  }
</style>
